export const isDev = process.env.NODE_ENV === 'development';

export const isSandbox = process.env.NEXT_PUBLIC_DD_ENV === 'sandbox';

export const isProd = process.env.NEXT_PUBLIC_DD_ENV === 'prod';
